<template>
  <div style="">
    <div class="sub-nav-box">
      <!-- judul halaman -->
      <h2>Presensi</h2>

      <!-- sub menu halaman -->
      <div class="sub-nav-menu">
        <p ref="PresensiCamera" @click="changeView('PresensiCamera')">
          Presensi
        </p>
        <p ref="Absensi" @click="changeView('Absensi')">Absen</p>
        <p ref="Cuti" @click="changeView('Cuti')">Cuti</p>
        <p ref="Riwayat" @click="changeView('Riwayat')">Riwayat</p>
      </div>
      <!-- end of sub menu halaman -->
    </div>

    <!-- main view halaman -->
    <div class="main-view">
      <component
        @changeComponent="changeView"
        ref="child"
        :is="view"
      ></component>
    </div>
    <!-- end of main view halaman -->
  </div>
</template>

<script>
import PresensiCamera from "@/components/presensi/PresensiCamera";
import Absensi from "@/components/presensi/Absensi";
import Cuti from "@/components/presensi/Cuti";
import Riwayat from "@/components/presensi/Riwayat";
import { mapState } from "vuex";

export default {
  components: {
    PresensiCamera,
    Absensi,
    Cuti,
    Riwayat,
  },

  data() {
    return {
      // current component / current sub page
      view: this.$route.params.view,
    };
  },

  methods: {
    // ganti component/ sub page
    changeView(view) {
      // matiin camera sebelum ganti component yang bukan presensiCamera
      if (this.view === "PresensiCamera" && view !== "PresensiCamera") {
        this.$refs.child.stopCameraStream();
      }
      // non-active nav
      let currentNav = this.$refs[this.view];
      currentNav.classList.remove("active");
      // active nav
      this.view = view;
      this.changeRouter();
      let nextNav = this.$refs[this.view];
      nextNav.classList.add("active");
    },
    changeRouter() {
      this.$router.push({
        name: `presensi-${this.userData.divisi}`,
        params: { view: this.view },
      });
    },
  },

  beforeRouteLeave(to, from, next) {
    // matiin camera
    if (this.view === "PresensiCamera") this.$refs.child.stopCameraStream();
    next();
  },

  mounted() {
    this.changeView(this.view);
  },

  computed: {
    ...mapState(["userData"]),
  },
};
</script>

<style scoped>
@import url("../../assets/css/karyawan/presensi.css");
</style>
